<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                @invoke-method="invokeMethod($event)"
                                action="showProductionStation"
                                perm="configuration.create"
                            ></bc-btn-add>
                            <bc-reorder
                                v-if="production_stations && production_stations.length > 1 && !$route.query.search && hasPerm('configuration.update')"
                                ref="reorder"
                                :items="production_stations"
                                primary-id="station_id"
                                @save="saveStationPositions($event)"
                            >
                                <template slot-scope="{ item }">
                                    {{ item.station }}
                                </template>
                            </bc-reorder>
                            <bc-btn-refresh
                                @invoke-method="dbGetProductionStations()"
                            ></bc-btn-refresh>
                            <bc-search-menu
                                :params="axiosParams"
                            >
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input
                                            v-model="filter.search"
                                            :params="axiosParams"
                                        ></bc-search-input>
                                    </v-list-tile>

                                    <v-divider></v-divider>

                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table
                        :headers="headers"
                        :items="production_stations"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                        :class="{ 'prevent-click': !hasPerm('configuration.update') }"
                    >
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="showProductionStation(props.item)">
								<td>{{ props.item.station }}</td>
								<td>{{ props.item.slug }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination
                        :page="page"
                        :params="axiosParams"
                        name="settings_production_stations"
                    ></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="production_station_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ currObjField('station_id') ? $t('lang.edit_production_station') : $t('lang.add_production_station') }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeProductionStationDialog"
                            :dialog-status="production_station_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="production_station">
                            <v-container grid-list-form>
                                <v-layout row wrap>
									<v-flex xs12>
										<v-text-field
											v-focus="production_station_dialog"
											v-model="production_station.station"
											:label="`${$t('lang.station')} *`"
											:counter="showCounter(production_station.station, 'production_station.station')"
											:rules="ifValid('production_station.station')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="production_station.slug"
											:label="`${$t('lang.slug')} *`"
											:counter="showCounter(production_station.slug, 'production_station.slug')"
											:rules="ifValid('production_station.slug')"
										></v-text-field>
									</v-flex>

                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currObjField('station_id') && hasPerm('configuration.delete')" color="error" @mouseup.left="$refs.delete_production_station.openDialog()">{{ $t('lang.delete') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeProductionStationDialog()">{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @mouseup.left="modifyProductionStation(currObjField('station_id') ? 'patch' : 'post', currObjField('station_id'))">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_production_station"
                :heading="$t('lang.delete_production_station')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyProductionStation('delete', currObjField('station_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [{ text: this.$t("lang.station"), sortable: false, width: "50%" }, { text: this.$t("lang.slug"), sortable: false, width: "50%" }],
            production_station: {
                station: "",
                slug: "",
            },
            current_obj: null,
            filter: {
                search: "",
                page_size: 0,
                page_num: 0,
            },
            production_station_dialog: false,
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "showProductionStation", perms: ["configuration.create"] },
                { title: this.$t("lang.reorder"), action: "openDialog", ref: "reorder", perms: ["configuration.update"] },
                { title: this.$t("lang.refresh"), action: "dbGetProductionStations" },
            ],
            dbGetProductionStations: _.debounce(this.getProductionStations, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchProduction", {
                url: "production_stations",
                method: "get",
                stateProperty: "production_stations",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.production_stations) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchProduction", {
                url: "production_stations",
                method: "get",
                stateProperty: "production_stations",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.production_stations) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_production_station: (state) => state.validation.rules_production_station,
            default_filter: (state) => state.production.production_stations_filter,
            page: (state) => state.production.page,
            production_stations: (state) => state.production.production_stations,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        saveStationPositions(positions = null) {
            if (positions) {
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchProduction", {
                        url: `production_stations/position`,
                        method: "patch",
                        stateProperty: "production_stations",
                        commit: true,
                        body: { station_id: positions },
                    })
                    .then((data) => {
                        if (typeof data != "undefined") {
                            this.$refs.reorder.close();
                        }
                        this.$store.commit("toggleModalLoader", false);
                    });
            }
        },
        closeProductionStationDialog() {
            this.production_station_dialog = false;
            this.$refs.delete_production_station.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getProductionStations() {
            this.startLoader();
            this.$store
                .dispatch("fetchProduction", {
                    url: "production_stations",
                    method: "get",
                    stateProperty: "production_stations",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.production_station_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        modifyProductionStation(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("production_station")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchProduction", {
                                pk: "station_id",
                                id: id,
                                url: `production_stations/${id ? id : ""}`,
                                method: method,
                                stateProperty: "production_stations",
                                mutate: true,
                                body: this.production_station,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeProductionStationDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showProductionStation(item = null) {
            this.current_obj = item;

            if (this.$refs.production_station) item ? this.$refs.production_station.resetValidation() : this.$refs.production_station.reset();

            this.$nextTick(() => {
                this.assignObj(this.production_station, item, this.rules_production_station);
                this.production_station_dialog = true;
            });
        },
    },
};
</script>
